module.exports = __webpack_public_path__ + "static/media/product_nuts.07e53b38.png";